import { JSX } from 'react';

import CancelIcon from '@mui/icons-material/CancelRounded';
import CheckIcon from '@mui/icons-material/CheckCircleRounded';
import CircleIcon from '@mui/icons-material/Circle';
import PropTypes from 'prop-types';

/**
 * ValidationIcon component displays an icon based on the validation status.
 *
 * @param {object} props - The component props.
 * @param {boolean} props.hasError - Indicates if there is an error in validation.
 * @param {boolean} props.hasPassed - Indicates if validation has passed.
 * @returns {JSX.Element} The icon representing the validation status.
 */
const ValidationIcon = ({ hasError, hasPassed }) => {
  if (hasPassed) {
    return <CheckIcon color="success" size="md" />;
  }

  if (hasError) {
    return <CancelIcon color="error" size="md" />;
  }

  return <CircleIcon color="disabled" size="md" />;
};

ValidationIcon.propTypes = {
  hasError: PropTypes.bool,
  hasPassed: PropTypes.bool
};

export default ValidationIcon;
